import axios from "axios";

export class DealernetApi {
    public static client() {
        const baseURL = DealernetApi.getBaseURL();

        const client = axios.create({
            baseURL,
            withCredentials: true,
            headers: { 
                'Accept': "application/json",
                'Pragma': 'no-cache'
            }
        });

        axios.defaults.withCredentials = true;

        axios.interceptors.response.use(function (response) {
            // Any status code that lie within the range of 2xx cause this function to trigger
            //do nothing
            return response;
        }, function (error) {
            // Any status codes that falls outside the range of 2xx cause this function to trigger
            //refresh if 401
            if(error.status == 401 || error.status == "401") {
                location.reload();
            }
            return Promise.reject(error);
        });

        return client;
    }

    public static getBaseURL() {
        let baseURL = window.appGlobals.API_URL || "";

        if (baseURL.endsWith("/")) {
            baseURL = baseURL.substr(0, baseURL.length - 1);
        }

        return baseURL;
    }
}
